module.exports = __webpack_public_path__ + "static/media/profile.ed744619.jpg";